import * as React from 'react';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import {useAuth} from '../../contexts/authContext';
import {doSignOut} from '../../service/auth';
import {Button, Dropdown, Layout, Menu, MenuProps, Spin, Switch} from 'antd';
import './MyHeader.css';
import {useCvBalanceStore} from "../../store/useCvBalanceStore";
import {useEffect} from "react";

const {Header} = Layout;

const MyHeader = () => {
    const {currentUser} = useAuth();
    const navigate = useNavigate();
    const location = useLocation(); // Hook to get the current path
    const {userLoggedIn} = useAuth();
    const {cvSent, sendsInPackage, isEnabled, isLoading, fetchBalance, handleToggleEnabled} = useCvBalanceStore();


    useEffect(() => {
        if (currentUser?.email && sendsInPackage === null) {
            fetchBalance(currentUser.email);
        }
    }, [currentUser, cvSent, sendsInPackage]);

    const handleToggleEnabled1 = async (checked) => {
        await handleToggleEnabled(checked, currentUser?.email);
    };

    // Determine selected key based on pathname
    let selectedKey = '';
    if (location.pathname.startsWith('/job-config')) {
        selectedKey = '/job-config';
    } else if (location.pathname.startsWith('/report')) {
        selectedKey = '/report';
    } else if (location.pathname.startsWith('/onboarding')) {
        selectedKey = '/onboarding';
    } else if (location.pathname.startsWith('/balance')) {
        selectedKey = '/balance';
    }


    // Items for the left side menu
    const leftMenuItems: MenuProps['items'] = userLoggedIn
        ? [
            {
                key: '/onboarding',
                label: <Link to={'/onboarding'}>Onboarding</Link>,
            },
            {
                key: '/job-config',
                label: <Link to={'/job-config'}>Job Config</Link>,
            },
            {
                key: '/report',
                label: <Link to={'/report'}>Report</Link>,
            },
        ]
        : [];

    return (
        <Header
            style={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <div className="logo">CV Postman App</div>

            {/* Left-side menu */}
            <Menu
                theme="dark"
                mode="horizontal"
                selectedKeys={[selectedKey]}
                items={leftMenuItems}
                style={{flex: 1}}
            />

            {userLoggedIn && (
                <div
                    style={{
                        display: 'flex',
                        gap: 1,
                        backgroundColor: '#001529',
                        height: '64px',          // додано
                        alignItems: 'center',    // для вертикального центрування
                        paddingInline: 16,       // трохи внутрішнього відступу для естетики
                    }}
                >
                    <Button className="right-menu-item" type="link"
                    >CV Job:
                        <Switch
                            checked={isEnabled}
                            onChange={handleToggleEnabled1}
                            loading={isLoading}
                            size="small"
                            checkedChildren="on"
                            unCheckedChildren="off"
                        />
                    </Button>
                    {cvSent >= 10 &&
                        <Button className={`right-menu-item ${cvSent >= sendsInPackage ? 'red' : 'white'}`} type="link"
                                onClick={() => navigate('/balance')}
                                style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            Balance:{' '}
                            {isLoading ? (
                                <Spin size="small"/>
                            ) : (
                                <span>{cvSent}/{sendsInPackage}</span>
                            )}
                        </Button>
                    }

                    <Button
                        className="right-menu-item"
                        type="link"
                        onClick={() => {
                            doSignOut().then(() => navigate('/login'));
                        }}
                    >
                        Logout
                    </Button>
                </div>
            )}


        </Header>
    );
};

export default MyHeader;
